var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 90,
    viewBox: "0 0 91 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 79.2605C39 79.2605 39.6732 64.6748 40.3464 58.8405C41.0196 53.0062 40.9074 40.4401 40.9074 37.6351C40.9074 34.8302 40.3464 33.9326 40.4586 30.2301C40.5708 26.5275 40.683 25.9666 41.9171 24.0592C43.1513 22.1518 44.1611 18.5615 45.6197 16.5419C47.0782 14.5224 46.6295 13.0638 48.649 11.6052C50.6686 10.1467 50.332 9.36128 51.3418 8.4637C52.3515 7.56612 53.6979 6.66854 54.3711 6.33194C55.0443 5.99535 55.9419 3.86359 57.4004 2.96601C58.859 2.06842 59.6444 2.29282 61.7762 3.97579C63.9079 5.65876 70.191 9.81007 71.4252 10.5955C72.6593 11.3808 74.5667 13.176 76.1375 15.42C77.7082 17.6639 80.7376 21.1421 81.2986 21.9274C81.2986 21.9274 83.9913 25.2934 84.4401 25.8544C84.8889 26.4153 86.9085 28.3784 86.1787 29.6134C85.4499 30.8476 83.2894 32.054 80.0644 28.828C76.8394 25.6021 74.6224 23.2738 74.6224 23.2738L69.1247 17.7761",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3584 3.65263C61.3584 3.65263 62.5612 2.54501 63.5144 2.44717C64.4685 2.34844 67.2169 2.23624 68.7877 2.18059C70.3585 2.12494 72.659 1.45175 74.3976 1.17081C76.1371 0.890764 76.9781 1.00206 79.3343 1.17081C81.6904 1.33956 82.6446 1.11516 84.0466 1.33956C85.4495 1.56395 89.0398 2.68593 89.0398 2.68593C89.0398 2.68593 91.3394 3.19037 89.8809 5.43433C88.4223 7.67828 83.9344 6.8929 80.0075 6.94945L77.4826 7.03831",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7827 10.1806C70.7827 10.1806 73.0626 7.40709 75.8621 7.03819C78.6617 6.66838 80.6813 8.0713 78.9417 11.1563C77.2022 14.2422 75.9923 15.2188 75.9923 15.2188",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7666 10.0344C60.7666 10.0344 62.8984 11.7174 63.6272 12.1662C64.3569 12.615 69.6302 16.2053 68.7326 18.2249C67.8351 20.2444 66.3765 23.386 64.0203 24.2279C61.6642 25.0698 61.359 23.7235 61.359 23.7235",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8765 13.7368C54.8765 13.7368 56.3916 15.532 58.1302 16.4852C59.8697 17.4384 63.0669 19.3467 62.0015 21.7585C60.9351 24.1712 59.7629 25.0069 57.9677 24.9503C57.9677 24.9503 56.055 24.953 55.3746 23.0026",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1743 19.3486C51.1743 19.3486 54.4281 22.7693 56.5598 23.6669",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3687 21.5073C48.3687 21.5073 51.398 22.7128 53.4176 21.9839",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5156 29.0561H47.7498C47.7498 29.0561 49.2084 29.1683 53.4153 25.9145C53.4153 25.9145 54.3201 25.3455 55.2697 23.667",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0134 20.6655C72.0134 20.6655 70.9758 21.8153 69.9095 22.6573C68.8441 23.4992 68.1709 24.5646 66.8245 25.911C65.4781 27.2574 62.7288 29.4457 60.3727 29.1647C58.0165 28.8838 55.0437 30.8477 54.875 32.8673C54.7071 34.8868 55.1559 41.3943 55.1559 41.3943C55.1559 41.3943 57.3999 56.0366 57.7365 58.785C58.0731 61.5334 61.5512 73.2019 62.3366 75.4459C63.122 77.6898 64.3561 81.0001 64.3561 81.0001",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8813 31.0718C43.8813 31.0718 46.294 33.2601 48.3693 33.4845C50.4454 33.7089 52.0718 32.7556 52.8015 32.6425",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4883 66.9805V77H14.6289V48.5625H25.7227C27.8581 48.5625 29.7331 48.9531 31.3477 49.7344C32.9753 50.5156 34.2253 51.6289 35.0977 53.0742C35.9701 54.5065 36.4062 56.1406 36.4062 57.9766C36.4062 60.763 35.4492 62.9635 33.5352 64.5781C31.6341 66.1797 28.9974 66.9805 25.625 66.9805H20.4883ZM20.4883 62.2344H25.7227C27.2721 62.2344 28.4505 61.8698 29.2578 61.1406C30.0781 60.4115 30.4883 59.3698 30.4883 58.0156C30.4883 56.6224 30.0781 55.4961 29.2578 54.6367C28.4375 53.7773 27.3047 53.3346 25.8594 53.3086H20.4883V62.2344Z",
    fill: "url(#paint0_diamond)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2424 65.8929) rotate(88.0754) scale(45.1147 45.0815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD458",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BF2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhand);
export default __webpack_public_path__ + "static/media/Phand.f746e31e03d8ba0d403af244c325a6f9.svg";
export { ForwardRef as ReactComponent };